/**
 * Helper class for localizing error property names.
 * Provides human-readable translations for property names used in error messages.
 */
export class ErrorLocalizationHelper {
  /**
   * Translates a property name to its localized human-readable form.
   * @param value - The property name to translate
   * @returns The localized property name, or the original value if no translation exists
   */
  static getPropertyName(value: string): string {
    switch (value) {
      case 'employeeNumber':
        return $localize`employee number`;
      case 'employeeName':
        return $localize`employee name`;
      case 'employeeId':
        return $localize`employee identifier`;
      case 'positionId':
        return $localize`position identifier`;
      case 'oldSalary':
        return $localize`old salary`;
      case 'changePercent':
        return $localize`change percent`;
      case 'changeAmount':
        return $localize`change amount`;
      case 'newSalary':
        return $localize`new salary`;
      case 'newActiveEnd':
        return $localize`new position active end`;
      case 'oldActiveEnd':
        return $localize`old position active end`;
      case 'newPositionEndReason':
        return $localize`new position end reason`;
      case 'oldPositionEndReason':
        return $localize`old position end reason`;
      default:
        if (!value) return '';
        console.warn(`Missing translation for property name: ${value}`);
        return value;
    }
  }
}
